import http from "./http";
import axios from "axios";
import { Loading } from "element-ui";
import config from "../common/config";


const exportExcelPostService = (url, param, needTrim = true, fileName = '') => {
    let loading = Loading.service({
        lock: true,
        text: "加载中",
        background: "rgba(0, 0, 0, 0.5)"
    });

    return new Promise((resolve, reject) => {
        let exportUrl = `${config.baseUrl}${url}`;

        try {
            console.log(exportUrl)
            var xhr = new XMLHttpRequest();
            xhr.onreadystatechange = function(){

                if(xhr.readyState == 4){
                    if(xhr.status == 200){
                        loading.close();
                    }else{
                        loading.close();
                    }
                }
            }
            xhr.open("post", exportUrl, true);
            xhr.responseType = "blob";
            xhr.setRequestHeader("Content-Type", "application/json");
            xhr.onload = function () {

                // 请求完成
                if (this.status === 200) {
                    // 返回200
                    var blob = this.response;
                    var reader = new FileReader();
                    reader.readAsDataURL(blob);    // 转换为base64，可以直接放入a表情href
                    reader.onload = function (e) {
                        // 转换完成，创建一个a标签用于下载
                        var a = document.createElement('a');
                        a.download = 'response.xlsx';
                        if (fileName != '') {
                            a.download = fileName
                        }
                        a.href = e.target.result;
                        $("body").append(a);    // 修复firefox中无法触发click
                        a.click();
                        $(a).remove();

                    }

                }else{
                    loading.close();
                }
            }

        var data = JSON.stringify(param);
        xhr.send(data)

        } catch (e) {
            loading.close();
            console.error(e);

        }
    })
}


const exportExcelWithCallBack = (url, param={},fileName, showMsg = true) => {
    let loading = Loading.service({
        lock: true,
        text: "加载中",
        background: "rgba(0, 0, 0, 0.5)"
      });
    return new Promise((resolve, reject) => {
        axios({
            // 用axios发送post请求
            method: 'get',
            withCredentials: true,
            url: `${process.env.NODE_ENV === 'development' ? '/api' : config.baseUrl}${url}?`, // 请求地址
            params: param,
            responseType: 'blob',//防止导出文件破损或乱码
            headers: {
                'Content-Type': 'application/json',
                channelId:config.buserchannel,
                Authorization: sessionStorage.getItem("token")
            }
        }).then(res => {
            // debugger
            try {
                if (res && res.data.type != 'application/json' && res.data.type != 'text/xml') {
                    //获取导出文件名字
                    let dFileName = getExportFileName(fileName, res);
                    //获取下载文件MIME Type
                    let bType = getFileNameContentType(dFileName);
                    // var blob = new Blob([res.data], { type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document;charset=utf-8" });
                    var blob = new Blob([res.data], { type: bType});
                    if (showMsg && blob.size == 0) {
                        loading.close();
                        reject("暂无数据可导出");
                        return;
                    }

                    var a = document.createElement('a');
                    var url = window.URL.createObjectURL(blob);
                    a.href = url;
                    a.download = dFileName;
                    var body = document.getElementsByTagName('body')[0];
                    body.appendChild(a);
                    a.click();
                    body.removeChild(a);
                    window.URL.revokeObjectURL(url);
                    loading.close();
                    resolve()
                }
                else {
                    loading.close();
                    if (res.data.type.includes('application/json')) {
                        let reader = new FileReader()
                        reader.onload = function (event) {
                            let content = reader.result
                            let message = JSON.parse(content).msg // 错误信息
                            // TODO 错误处理
                            reject(message);
                        }
                        reader.readAsText(res.data)
                    }
                    else {
                        reject('数据导出失败');
                    }
                }

            } catch (e) {
                loading.close();
                reject(e)
            }
        }).catch(error => {
            loading.close();
            reject(error)
        })
    })
}
//使用post方式导出文件
const exportFileByPostService = (url, param, fileName, needTrim = true) => {
    let loading = Loading.service({
        lock: true,
        text: "加载中",
        background: "rgba(0, 0, 0, 0.5)"
      });
    return new Promise((resolve, reject) => {
        axios({
            // 用axios发送post请求
            method: 'post',
            withCredentials: true,
            url: `${process.env.NODE_ENV === 'development' ? '/api' : config.baseUrl}${url}`, // 请求地址
            data: param,
            responseType: 'blob',//防止导出文件破损或乱码
            headers: {
                'Content-Type': 'application/json',
                deptCode: sessionStorage.getItem('deptCode'),
                userCode: sessionStorage.getItem("userCode"),
                channelId:"JHL20220809JHL0ZHCS0000",
                Authorization: sessionStorage.getItem("accessToken")
            }
        }).then(res => {
            if (res.data.type.includes('application/json')) {//处理错误信息
                let reader = new FileReader()
                reader.onload = function (event) {
                  let content = reader.result
                  let message = JSON.parse(content).msg
                  reject(message);
                }
                reader.readAsText(res.data);
                loading.close();
                return
              }
            try {
                var blob = new Blob([res.data]);
                if('msSaveOrOpenBlob' in navigator){//解决edge和ie浏览器导出无响应问题
                    window.navigator.msSaveOrOpenBlob(blob, fileName);
                    loading.close();
                }else{
                    var filename = fileName;
                    var a = document.createElement('a');
                    var url =window.URL.createObjectURL(blob);
                    a.href = url;
                    a.download = filename;
                    var body = document.getElementsByTagName('body')[0];
                    body.appendChild(a);
                    a.click();
                    body.removeChild(a);
                    window.URL.revokeObjectURL(url);
                    loading.close();
                }
            } catch (e) {
                reject(e)
                loading.close();
            }
        }).catch(error=>{
            reject(error);
            loading.close();
        })
    })
}
//下载文件
const getBlob=(url, cb)=> {
    var xhr = new XMLHttpRequest();
    xhr.open("GET", url, true);
    xhr.responseType = "blob";
    xhr.onload = function() {
      if (xhr.status === 200) {
        cb(xhr.response);
      }
    };
    xhr.send();
  }
const saveAs=(blob, filename)=> {
    if (window.navigator.msSaveOrOpenBlob) {
      navigator.msSaveBlob(blob, filename);
    } else {
      var link = document.createElement("a");
      var body = document.querySelector("body");

      link.href = window.URL.createObjectURL(blob);
      link.download = filename;

      // fix Firefox
      link.style.display = "none";
      body.appendChild(link);

      link.click();
      body.removeChild(link);

      window.URL.revokeObjectURL(link.href);
    }
  }
const downloadFile=(url, filename)=> {
    getBlob(url, (blob)=> {
        saveAs(blob, filename);
    });
  }

// 获取导出文件的名字（优先使用传入名字，未传入使用接口返回。优先使用接口返回尾缀格式）
const getExportFileName = (fileName, res) => {
    //解码UTF-8编码   区别后端的写法区别 增加utf-8
    let respHeaderDisposition = decodeURIComponent(res.headers["content-disposition"]);
    let responseFileName = respHeaderDisposition.split("filename=")[1];
    if (!responseFileName) {
        responseFileName = respHeaderDisposition.split("filename*=UTF-8''")[1];
    }
    if(!responseFileName) {
        responseFileName = respHeaderDisposition.split("filename*=utf-8''")[1];
    }
    // 历史遗留原因接口有的返回了两遍filename（例：项目工单闭合率统计）
    //解析出结果为：(项目工单闭合率.xls;filename*=utf-8''项目工单闭合率.xls) 处理此种情况
    if (responseFileName.includes('filename')) {
        let abnormalArry = responseFileName.split(';');
        if (abnormalArry.length > 0) {
            responseFileName = abnormalArry[0];
        }
    }
    let dFileName = '';
    if (responseFileName) {
        dFileName = responseFileName;
        if (fileName && fileName.length > 0) {
            let repFileCom = responseFileName.split(".");
            if (repFileCom.length == 2) {
                let fileSuffix = repFileCom[1];
                let customFileArray = fileName.split('.');
                if (customFileArray.length == 2) {
                    //方法传入文件名正常带尾缀格式
                    let customFileName = customFileArray[0];
                    dFileName = customFileName + '.' + fileSuffix;
                }
                else {
                    //方法传入文件名未带尾缀格式
                    dFileName = fileName + '.' +  fileSuffix;
                }
            }
        }
    }
    else if (fileName && fileName.length > 0) {
        //接口未返回名字，有自定义名字
        dFileName = fileName;
    }
    else {
        //接口未返回名字，无自定义名字
        dFileName = '报表.xlsx';
    }

    return dFileName;
}
// 获取资源文件类型 content-type MIME Type定义
const getFileNameContentType = (fileName) => {
    let contentType = 'charset=utf-8';
    let fileNameArray = fileName.split(".");
    if (fileNameArray.length == 2) {
        let fileSuffix = fileNameArray[1];
        switch (fileSuffix) {
            case 'doc':
                contentType = 'application/msword; charset=utf-8';
                break;
            case 'docx':
                contentType = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document; charset=utf-8';
                break;
            case 'xls':
                contentType = 'application/vnd.ms-excel; charset=utf-8';
                break;
            case 'xlsx':
                contentType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet; charset=utf-8';
                break;
                case 'zip':
                contentType = 'application/zip';
                break;
            default:
                break;
        }
    }
    return contentType;
}
export {
    exportExcelWithCallBack,exportExcelPostService,exportFileByPostService,
    downloadFile
}
